import { FC } from "react";

import { important, px } from "csx";
import { Content, Horizontal } from "gls/lib";
import { classes, style } from "typestyle";
import { Colours } from "../../styles";
import { InputLayout } from "./InputLayout";
import { inputStyles } from "./styles";
import { InputProps } from "./types";

interface TextInputProps extends InputProps<string> {
  password?: boolean;
  maxLength?: number;
  suffix?: string;
  hideErrors?: boolean;
}

export const TextInput: FC<TextInputProps> = ({
  id,
  value,
  label,
  labelPosition = "top",
  name,
  password,
  disabled,
  required,
  readonly,
  placeholder,
  maxLength,
  onBlur,
  onChange,
  errors,
  transparent,
  suffix,
  hideErrors,
  labelSize,
}) => {
  return (
    <InputLayout
      label={label}
      errors={errors}
      required={required}
      labelPosition={labelPosition}
      hideErrors={hideErrors}
      size={labelSize}
      htmlFor={id}
    >
      <Horizontal
        sizing="stretch"
        spacing={px(5)}
        className={classes(
          transparent &&
            style({
              borderColor: important("transparent"),
              background: important("transparent"),
            }),
          inputStyles.container,
          hideErrors &&
            (errors?.length || 0) > 0 &&
            style({
              borderColor: Colours.red,
            }),
        )}
      >
        <input
          id={id}
          maxLength={maxLength}
          disabled={disabled || readonly}
          type={password ? "password" : "text"}
          value={value ?? ""}
          onBlur={onBlur}
          onChange={({ target }) => onChange(target.value)}
          className={classes(inputStyles.input, readonly && "readonly")}
          placeholder={placeholder}
          name={name}
          required={required}
          data-testid={id}
        />

        {suffix && (
          <Content verticalAlign="center" className={inputStyles.suffix}>
            {suffix}
          </Content>
        )}
      </Horizontal>
    </InputLayout>
  );
};
